<div
  id="AppInfoComponent"
  [hidden]="hiddenContainer"
  class="card esri-widget animation-on-tool-open"
  #appInfoComponentRef
  gisDraggableWidget
  [dragHandle]="dragArea"
  xmlns:color="http://www.w3.org/1999/xhtml"
>
  <!--- the panel header -->
  <div class="card-header" #dragArea>
    <div class="row">
      <div class="col-md-9" translate>
        WIDGET.APPINFO.PANEL_HEADING
      </div>
      <div class="col-md-3">
        <i class="material-icons md-18 float-right" (click)="destroySelf()">close</i>
        <i class="material-icons md-18 float-right pr-1" (click)="collapseWidget()">exit_to_app</i>
      </div>
    </div>
  </div>
  <!-- the panel body -->
  <div class="card-body">
    <table class="table table-sm table-borderless">
      <tr>
        <td class="label">Company:</td>
        <td class="detail">SBB CFF FFS</td>
      </tr>
      <tr>
        <td class="label">App:</td>
        <td class="detail" translate>WIDGET.APPINFO.APPLICATION</td>
      </tr>
      <tr class="section">
        <td class="label">ImmoGIS-Version:</td>
        <td *ngIf="stage === 'dev'" class="detail">{{ version }}</td>
        <td *ngIf="stage !== 'dev'" class="detail">{{ version }}</td>
      </tr>

      <tr>
        <td class="label" colspan="2">{{ supportInfo.label }}</td>
      </tr>
      <tr>
        <td class="label">Kontakt:</td>
        <td class="detail">{{ supportInfo.kontakt }}</td>
      </tr>
      <tr>
        <td class="label">Tel.:</td>
        <td class="detail">{{ supportInfo.tel }}</td>
      </tr>
      <tr>
        <td class="label">Sharepoint:</td>
        <td class="detail">
          <a href="https://sbb.sharepoint.com/sites/immorail2/SitePages/Home.aspx" target="_blank"
            >ImmoRail II und ImmoGIS</a
          >
        </td>
      </tr>
      <tr>
        <td></td>
        <td class="detail">{{ supportInfo.beschreibung }}</td>
      </tr>
    </table>
  </div>
</div>
